import { Component, OnInit } from '@angular/core';
import { RespostaManifestoDTO } from 'src/app/entity/RespostaManifestoDTO';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PAGINA_HOME_USUARIO_INTERNO } from 'src/app/tools/URL';
import { ERRO_CAMPO_OBRIGATORIO, ERRO_DATA_OBRIGATORIA, ERRO_RESPOSTA_OBRIGATORIA, ERRO_STATUS_INVALIDO } from 'src/app/tools/Mensagens';
import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';

@Component({
  selector: 'resposta',
  templateUrl: './resposta-manifesto-operador.component.html',
  styleUrls: ['./resposta-manifesto-operador.component.css']
})
export class RespostaManifestoOperadorComponent implements OnInit {

  header: string;
  resposta: FormGroup;
  listaStatus: any;

  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private manifestoService: ManifestoService) {

      if (!Object.keys(MANIFESTO_ENUM).includes(this.activatedRoute.snapshot.params.tipoManifesto.toUpperCase())) {

        this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

      }

      this.resposta = this.formBuilder.group(new RespostaManifestoDTO());
      this.resposta.controls.idManifesto.setValue(parseInt(this.activatedRoute.snapshot.params.id));
      this.resposta.controls.tipoManifesto.setValue(this.activatedRoute.snapshot.params.tipoManifesto.toUpperCase());
      this.resposta.controls.responsavelRegistro.setValue(this.authService.usuarioLogado.username);

      this.manifestoService.statusFindAll().subscribe(listaStatus => this.listaStatus = listaStatus, err => console.log(err));

      this.header = 'Resposta da manifestação código ' + this.resposta.get('idManifesto').value;

  }

  ngOnInit() { }

  validarResposta() {

    let alerts = '';

    if (!this.resposta.get('idStatus').valid) {

      alerts = alerts + ERRO_STATUS_INVALIDO + '\n';

    }

    if (!this.resposta.get('responsavelRetorno').valid) {

      alerts = alerts + ERRO_CAMPO_OBRIGATORIO + '\n';

    }

    if (!this.resposta.get('dataRetorno').valid) {

      alerts = alerts + ERRO_DATA_OBRIGATORIA + '\n';

    }

    if (!this.resposta.get('respostaManifesto').valid) {

      alerts = alerts + ERRO_RESPOSTA_OBRIGATORIA + '\n';

    }

    if (alerts.length > 0) {

      alert(alerts);

    }

  }

  salvar() {

    this.validarResposta();

    if (this.resposta.valid) {

      this.manifestoService.salvarResposta(this.resposta.getRawValue())
      .subscribe(retorno => {

        alert(retorno);
        this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

      }, err => console.log(err));

    }

  }

  voltarEdicao() {

    this.resposta = this.formBuilder.group(new RespostaManifestoDTO());

    this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

  }

}
